import { DateTime } from 'luxon';

import type { Notification, NotificationFilter, NotificationHubInfo } from './notification-hub.types';

export const TOGGLE_NOTIFICATION_HUB = 'TOGGLE_NOTIFICATION_HUB';
type ToggleNotificationHubAction = {
  type: typeof TOGGLE_NOTIFICATION_HUB;
  isOpen: boolean;
};
export const toggleNotificationHub = (isOpen: boolean): ToggleNotificationHubAction => ({
  type: TOGGLE_NOTIFICATION_HUB,
  isOpen,
});

export const SET_ACTIVE_FILTER = 'SET_NOTIFICATION_HUB_ACTIVE_FILTER';
type SetActiveFilterAction = {
  type: typeof SET_ACTIVE_FILTER;
  filter: NotificationFilter;
};
export const setActiveFilter = (filter: NotificationFilter): SetActiveFilterAction => ({
  type: SET_ACTIVE_FILTER,
  filter,
});

export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
type AddNotificationAction = {
  type: typeof ADD_NOTIFICATION;
  notification: Notification;
};
export const addNotification = (notification: Notification): AddNotificationAction => ({
  type: ADD_NOTIFICATION,
  notification,
});

export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
type SetNotificationsAction = {
  type: typeof SET_NOTIFICATIONS;
  notifications: Notification[];
};
export const setNotifications = (notifications: Notification[]): SetNotificationsAction => ({
  type: SET_NOTIFICATIONS,
  notifications,
});

export const SET_UNREAD_COUNT = 'SET_NOTIFICATION_HUB_UNREAD_COUNT';
type SetUnreadCountAction = {
  type: typeof SET_UNREAD_COUNT;
  count: number;
};
export const setUnreadCount = (count: number): SetUnreadCountAction => ({
  type: SET_UNREAD_COUNT,
  count,
});

export const MARK_AS_READ_REQUEST = 'MARK_NOTIFICATION_AS_READ_REQUEST';
type MarkAsReadRequestAction = {
  type: typeof MARK_AS_READ_REQUEST;
  notificationID: number;
};
export const markAsReadRequest = (notificationID: number): MarkAsReadRequestAction => ({
  type: MARK_AS_READ_REQUEST,
  notificationID,
});

export const MARK_AS_READ = 'MARK_NOTIFICATION_AS_READ';
type MarkAsReadAction = {
  type: typeof MARK_AS_READ;
  notificationID: number;
  timestampUtc: string;
};
export const markAsRead = (notificationID: number): MarkAsReadAction => ({
  type: MARK_AS_READ,
  notificationID,
  timestampUtc: DateTime.now().toISO(),
});

export const MARK_ALL_AS_READ_REQUEST = 'MARK_ALL_NOTIFICATIONS_AS_READ_REQUEST';
type MarkAllAsReadRequestAction = {
  type: typeof MARK_ALL_AS_READ_REQUEST;
  priorityFilter?: string;
};
export const markAllAsReadRequest = (priorityFilter?: string): MarkAllAsReadRequestAction => ({
  type: MARK_ALL_AS_READ_REQUEST,
  priorityFilter,
});

export const MARK_ALL_AS_READ = 'MARK_ALL_NOTIFICATIONS_AS_READ';
type MarkAllAsReadAction = {
  type: typeof MARK_ALL_AS_READ;
  priorityFilter?: string;
  timestampUtc: string;
};
export const markAllAsRead = (priorityFilter?: string): MarkAllAsReadAction => ({
  type: MARK_ALL_AS_READ,
  priorityFilter,
  timestampUtc: DateTime.now().toISO(),
});

export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
type DismissNotificationAction = {
  type: typeof DISMISS_NOTIFICATION;
  notificationID: number;
  timestampUtc: string;
};
export const dismissNotification = (notificationID: number): DismissNotificationAction => ({
  type: DISMISS_NOTIFICATION,
  notificationID,
  timestampUtc: DateTime.now().toISO(),
});

export const FETCH_NOTIFICATIONS_REQUEST = 'FETCH_NOTIFICATIONS_REQUEST';
type FetchNotificationsRequestAction = {
  type: typeof FETCH_NOTIFICATIONS_REQUEST;
};
export const fetchNotificationsRequest = (): FetchNotificationsRequestAction => ({
  type: FETCH_NOTIFICATIONS_REQUEST,
});

export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
type FetchNotificationsSuccessAction = {
  type: typeof FETCH_NOTIFICATIONS_SUCCESS;
  notifications: Notification[];
  unreadCount: number;
};
export const fetchNotificationsSuccess = (notifications: Notification[], unreadCount: number): FetchNotificationsSuccessAction => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  notifications,
  unreadCount,
});

export const FETCH_NOTIFICATIONS_FAILURE = 'FETCH_NOTIFICATIONS_FAILURE';
type FetchNotificationsFailureAction = {
  type: typeof FETCH_NOTIFICATIONS_FAILURE;
};
export const fetchNotificationsFailure = (): FetchNotificationsFailureAction => ({
  type: FETCH_NOTIFICATIONS_FAILURE,
});

export const PERSIST_NOTIFICATION = 'PERSIST_NOTIFICATION';
type PersistNotificationAction = {
  type: typeof PERSIST_NOTIFICATION;
  hubInfo: NotificationHubInfo;
};
export const persistNotification = (hubInfo: NotificationHubInfo): PersistNotificationAction => ({
  type: PERSIST_NOTIFICATION,
  hubInfo,
});

export type NotificationHubAction =
  | ToggleNotificationHubAction
  | SetActiveFilterAction
  | AddNotificationAction
  | SetNotificationsAction
  | SetUnreadCountAction
  | MarkAsReadRequestAction
  | MarkAsReadAction
  | MarkAllAsReadRequestAction
  | MarkAllAsReadAction
  | DismissNotificationAction
  | FetchNotificationsRequestAction
  | FetchNotificationsSuccessAction
  | FetchNotificationsFailureAction
  | PersistNotificationAction;
